<div *ngIf="actionHistoryList.length > 0">
  <div class="ng-Header col-xs-12">
    <i nz-icon nzType="unordered-list" nzTheme="outline"></i> Application
    History
  </div>

  <nz-table
    #historyTable
    [nzData]="actionHistoryList"
    nzTableLayout="fixed"
    nzBordered
    [nzFrontPagination]="true"
    [nzPageSize]="pageSize"
    [(nzPageIndex)]="currentPage"
    [nzShowSizeChanger]="false"
    [nzShowTotal]="totalRowRangeTemplate"
    nzSize="middle"
    nzAlign="middle"
  >
    <ng-template #totalRowRangeTemplate let-range="range" let-total>
      <div style="text-align: left">
        Showing {{ range[0] }}-{{ range[1] }} of {{ total }} items
      </div>
    </ng-template>

    <thead>
      <tr>
        <th style="width: 5%; text-align: center">Sl.</th>
        <th style="width: 10%; text-align: center">Date</th>
        <!-- <th style="width: 23%; text-align: center">Remarks</th> -->
        <th style="width: 10%; text-align: center">Status</th>
        <th style="width: 10%; text-align: center">Remarks</th>
        <!-- <th style="width: 15%; text-align: center">Name</th> -->
        <th style="width: 10%; text-align: center">Designation</th>
        <th style="width: 15%; text-align: center">Email</th>
        <!-- <th style="width: 12%; text-align: center">Contact No</th> -->
      </tr>
    </thead>
    <tbody>
      <tr
        *ngFor="let data of historyTable.data; let i = index"
        [class.inspection-rollbacked-row]="isInspectionRollbacked(data)"
      >
        <td style="text-align: center">
          {{ (currentPage - 1) * pageSize + i + 1 }}
        </td>
        <td style="text-align: center; vertical-align: middle">
          {{ data?.createdAt | date: "dd-MM-yyyy, h:mm a" }}
        </td>
        <!-- <td style="text-align: center; vertical-align: middle">
      {{ data?.description }}
    </td> -->
        <td style="text-align: center; vertical-align: middle">
          {{ data?.actionStatus }}
        </td>
        <td style="text-align: center; vertical-align: middle">
          {{ data?.remarks || "N/A" }}
        </td>
        <!-- <td style="text-align: center; vertical-align: middle">
      {{ data?.name }}
    </td> -->
        <td style="text-align: center; vertical-align: middle">
          {{ data?.designation }}
        </td>
        <td style="text-align: center; vertical-align: middle">
          {{ data?.email }}
        </td>
        <!-- <td style="text-align: center; vertical-align: middle">
      {{ data?.contactNo }}
    </td> -->
      </tr>
    </tbody>
  </nz-table>
</div>
